import React, {createContext, useState, useEffect} from 'react'
import axios from 'axios'

const AppContext = createContext()

function AppContextProvider({children, token}) {
  const [jwt, setJwt] = useState(null)
  const [formMenuOptions, setFormMenuOptions] = useState([])

  useEffect(() => {
    setJwt(token)
    updateFormMenuOptions()
  }, [])

  const updateFormMenuOptions = () => {
    fetchFormMeunOptions().then(menuOptions => setFormMenuOptions(menuOptions))
  }

  const fetchFormMeunOptions = async () => {
		try {
			const result = await axios({
				method: 'get',
				url: '/api/plugin_objects/menu',
				params: {
					jwt: token
				}
			})
			console.log('RESULT', result)	
      return result.data
		} catch (error) {
			console.log(error)
		}
	}
 
  return (
    <AppContext.Provider value={{
      jwt,
      setJwt,
      formMenuOptions,
      setFormMenuOptions,
      updateFormMenuOptions
    }}>
      {children}
    </AppContext.Provider>
  )
}

export {AppContextProvider, AppContext}
